import React, {Component} from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import api from '../../utils/api';

class ModalAddEditChapter extends Component {
    state = {
        chapter: {
            ...this.props.chapter
        },
        files: [],
        hideFiles: []
    };

    //Renders
    renderModalHeader = () => (
        <div className="modal-header">
            <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={this.props.resetChapterState}
            >
                <span aria-hidden="true">
                    &times;
                </span>
            </button>
            <h4
                className="modal-title"
                id="myModalLabel"
            >
                Add/Edit Chapter Info
            </h4>
        </div>
    );

    renderModalFooter = () => (
        <div className="modal-footer">
            <button
                type="button"
                className="btn btn-default"
                data-dismiss="modal"
                onClick={this.props.resetChapterState}
            >
                Close
            </button>
            <button
                type="button"
                className="btn btn-primary"
                data-dismiss="modal"
                onClick={()=>
                    {
                        this.props.editChapterModal
                            ? this.props.editChapterInfo(this.state.chapter, this.state.files, this.props.subjectId)
                            : this.props.addNewChapter(this.state.chapter, this.state.files, this.props.subjectId);
                        this.props.resetChapterState()
                    }
                }
            >
                Save changes
            </button>
        </div>
    );

    renderInputs = (title, name, placeholder) => (
        <div className="form-group">
            <label>{title}</label>
            <input
                type="text"
                className="form-control"
                placeholder={placeholder}
                value={this.state.chapter[name]}
                onChange={(e)=> this.onChangeState(e, name)}
            />
        </div>
    );

    renderTextArea = (name) => (
        <div className="form-group">
            <label>Description</label>
            <textarea
                className="form-control"
                rows="5"
                value={this.state.chapter[name]}
                onChange={(e)=> this.onChangeState(e, name)}
            >
            </textarea>
        </div>
    );

    //Actions
    onChangeState = (e, name) => (
        this.setState({
            chapter: {
                ...this.state.chapter,
                [name]: e.target.value
            }
        })
    );

    //Lifecycle
    componentWillReceiveProps(nextProps) {
        if (this.props.chapter !== nextProps.chapter) {
            this.setState({chapter: nextProps.chapter});
        }
    };

    readFile = (file) => {
        var fr = new FileReader();
        fr.onload = function () {
            $('[data-file="'+ file.name +'"]').attr('src', fr.result);
        }
        fr.readAsDataURL(file);

    }

    render() {
        return (
            <div
                className={`modal fade ${this.props.open ? 'show in' : ''}`}
                id="EditChapterModal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="myModalLabel"
            >
                <div
                    className="modal-dialog"
                    role="document"
                >
                    <div className="modal-content">
                        {this.renderModalHeader()}
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-sm-3 hidden">
                                    {this.renderInputs('Chapter Number', 'number', 'No.')}
                                </div>
                                <div className="col-sm-9">
                                    {this.renderInputs('Chapter Title', 'name', 'Chapter')}
                                </div>
                                <div className="col-sm-12">
                                    {this.renderTextArea('description')}
                                </div>
                                <div className="col-sm-12">
                                    <div className={"row"}>
                                        <div className="col-md-12">
                                            Files
                                        </div>
                                    </div>

                                    {this.props.chapter.File &&

                                    <span>
                                        {this.props.chapter.File.map(f => {
                                            if(this.state.hideFiles.filter(hf => hf.id == f.id).length === 0) {

                                                if (f.type.indexOf("image") > -1) {


                                                    return (
                                                        <div className="file-preview-container">
                                                            <button className={"btn btn-delete"}
                                                                    onClick={(e) => {
                                                                        this.props.deleteChapterFile(f.id);
                                                                        let {hideFiles} = this.state;
                                                                        hideFiles.push(f);
                                                                        this.setState({hideFiles});
                                                                    }}
                                                            ><i className={"zmdi zmdi-close"}/></button>
                                                            <img src={api.makeFileURL(f.url)} data-file={f.name}
                                                                 className="chapter-file-preview"/></div>
                                                    )
                                                } else if (f.type.indexOf("zip") > -1) {
                                                    return (
                                                        <a className="file-preview-container" target="_blank"
                                                           href={api.makeFileURL(f.url)}>
                                                            <button className={"btn btn-delete"}
                                                                    onClick={(e) => {
                                                                        this.props.deleteChapterFile(f.id);
                                                                        let {hideFiles} = this.state;
                                                                        hideFiles.push(f);
                                                                        this.setState({hideFiles});
                                                                    }}
                                                            ><i className={"zmdi zmdi-close"}/></button>
                                                            <i className="zmdi zmdi-folder"/>
                                                            <small>{f.name}</small>

                                                        </a>
                                                    )
                                                } else {
                                                    return (
                                                        <a className="file-preview-container" target="_blank"
                                                           href={api.makeFileURL(f.url)}>
                                                            <button className={"btn btn-delete"}
                                                                    onClick={(e) => {
                                                                        this.props.deleteChapterFile(f.id);
                                                                        let {hideFiles} = this.state;
                                                                        hideFiles.push(f);
                                                                        this.setState({hideFiles});
                                                                    }}
                                                            ><i className={"zmdi zmdi-close"}/></button>
                                                            <i className="zmdi zmdi-file"/>
                                                            <small>{f.name}</small>

                                                        </a>
                                                    )
                                                }
                                            }

                                        })}
                                    </span>}


                                    {this.state.files.map((f, fi) => {
                                        if(f.type.indexOf("image") > -1){
                                            this.readFile(f);
                                            return (
                                                <div className="file-preview-container">
                                                    <button className={"btn btn-delete"}
                                                            onClick={(e) => {
                                                                let {files} = this.state;
                                                                files.splice(fi, 1);
                                                                this.setState({files});
                                                            }}
                                                    ><i className={"zmdi zmdi-close"}
                                                    /></button>
                                                    <img src={""} data-file={f.name} className="chapter-file-preview" /></div>
                                            )
                                        }else if(f.type.indexOf("zip") > -1){
                                            return (
                                                <div className="file-preview-container">
                                                    <button className={"btn btn-delete"}
                                                            onClick={(e) => {
                                                                let {files} = this.state;
                                                                files.splice(fi, 1);
                                                                this.setState({files});
                                                            }}
                                                    ><i className={"zmdi zmdi-close"} /></button>
                                                    <i className="zmdi zmdi-folder" />
                                                    <small>{f.name}</small>

                                                </div>
                                            )
                                        }else{
                                            return (
                                                <div className="file-preview-container">
                                                    <button className={"btn btn-delete"}
                                                            onClick={(e) => {
                                                                let {files} = this.state;
                                                                files.splice(fi, 1);
                                                                this.setState({files});
                                                            }}
                                                    ><i className={"zmdi zmdi-close"} /></button>
                                                    <i className="zmdi zmdi-file" />
                                                    <small>{f.name}</small>

                                                </div>
                                            ) 
                                        }
                                    })}

                                    <button className={"btn btn-file-upload btn-default"} onClick={(e) => $('#upload-chapter-file').trigger('click')}><i className="zmdi zmdi-plus" /></button>
                                    <input
                                        type="file"
                                        className="btn btn-file-upload btn-default hidden"
                                        id="upload-chapter-file"
                                        onChange={(e) => {
                                            let {files} = this.state;
                                            const data = new FormData();
                                            data.append('file', e.target.files[0], "chapter-file-" + new Date().getTime().toString() + e.target.files[0].name);

                                            files.push(e.target.files[0]);
                                            this.setState({files});
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        {this.renderModalFooter()}
                    </div>
                </div>
            </div>
        )
    };
}

ModalAddEditChapter.propTypes = {
    chapter: PropTypes.object.isRequired,
    editChapterInfo: PropTypes.func.isRequired,
    addNewChapter: PropTypes.func.isRequired,
    courseId: PropTypes.any,
    resetChapterState: PropTypes.func.isRequired
};

export default ModalAddEditChapter;


// WEBPACK FOOTER //
// ./src/components/AdminPanel/ModalAddEditChapter.js